import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "vue";

import { AdditionalRoleResponse } from "@/types";
import { SnakeToCamelCaseObj } from "@/types/utils/CaseTypes";
import OfficeAddress from "@/components/profile/OfficeAddress.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalRoleOffice',
  props: {
    role: null
  },
  setup(__props: any) {

const props = __props as {
  role: SnakeToCamelCaseObj<AdditionalRoleResponse>;
};



const { role } = toRefs(props);
const offices = computed(() =>
  role.value.offices.map((o) => ({ ...o, type: "Agency" }))
);

return { __sfc: true,props, role, offices, OfficeAddress }
}

})